import { Component, OnInit, OnDestroy, Input, HostListener, ElementRef, Output, EventEmitter, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { MenuStateService } from '../../../_services/app/menu-state.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../../_services/app/notification.service';
import { Contact } from '../../../_models/contact.model';
import { AdminContactService } from '../../../_services/api/admin-contact.service';

@Component({
  selector: 'app-admin-contact-card',
  imports: [CommonModule],
  templateUrl: './admin-contact-card.html',
  styleUrl: './admin-contact-card.scss',
})
export class AdminContactCard implements OnInit, OnDestroy {
  @Input() contact!: Contact;
  @Output() contactUpdated = new EventEmitter<void>();
  @Output() contactArchived = new EventEmitter<void>();
  @Output() contactDeleted = new EventEmitter<void>();
  
  menuOpen = false;
  showDeleteModal = false;
  isUpdatingVisibility = false;

  constructor(
    private menuStateService: MenuStateService,
    private notification: NotificationService,
    private elementRef: ElementRef,
    private router: Router,
    private contactService: AdminContactService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.menuStateService.activeMenu$.subscribe(activeId => {
      this.menuOpen = activeId === this.contact.id;
    });
    if (isPlatformBrowser(this.platformId)) {
        document.addEventListener('click', this.closeMenu.bind(this));
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
        document.removeEventListener('click', this.closeMenu.bind(this));
    }
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    } else {
      this.menuStateService.setActiveMenu(this.contact.id);
    }
  }

  @HostListener('document:click', ['$event'])
  closeMenu(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.menuOpen = false;
    }
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    }
  }

  toggleVisibility(): void {
    if (this.isUpdatingVisibility) return;
  
    this.isUpdatingVisibility = true;
    this.menuStateService.setActiveMenu(null);
    this.menuOpen = false;
    
    if (this.contact.isRead) {
      this.contactService.markAsUnread(this.contact.id).subscribe({
        next: () => {
          this.contact.isRead = false;
          this.contactUpdated.emit();
          this.isUpdatingVisibility = false;
          this.notification.showSuccess("Le message a été marqué comme non lu.");
        },
        error: (error) => {
          console.error('Error making contact as no read:', error);
          this.isUpdatingVisibility = false;
          this.notification.showError("Une erreur est survenue. Veuillez réessayer.");
        }
      });
    } else {
      this.contactService.markAsRead(this.contact.id).subscribe({
        next: () => {
          this.contact.isRead = true;
          this.contactUpdated.emit();
          this.isUpdatingVisibility = false;
          this.notification.showSuccess("Le message a été marqué comme lu.");
        },
        error: (error) => {
          console.error('Error making contact requets as read:', error);
          this.isUpdatingVisibility = false;
          this.notification.showError("Une erreur est survenue. Veuillez réessayer.");
        }
      });
    }
  }

   toggleArchive(): void {
    if (this.isUpdatingVisibility) return;
  
    this.isUpdatingVisibility = true;
    this.menuStateService.setActiveMenu(null);
    this.menuOpen = false;
    
    if (this.contact.isArchived) {
      this.contactService.unarchiveContact(this.contact.id).subscribe({
        next: () => {
          this.contact.isArchived = false;
          this.contactArchived.emit();
          this.isUpdatingVisibility = false;
          this.notification.showSuccess("Le message a été retiré des archives.");
        },
        error: (error) => {
          console.error('Error making contact as no archived:', error);
          this.isUpdatingVisibility = false;
          this.notification.showError("Impossible de modifier l’archive. Réessayez.");
        }
      });
    } else {
      this.contactService.archiveContact(this.contact.id).subscribe({
        next: () => {
          this.contact.isArchived = true;
          this.contactArchived.emit();
          this.isUpdatingVisibility = false;
          this.notification.showSuccess("Le message a été désarchivé.");
        },
        error: (error) => {
          console.error('Error making contact requets as archived:', error);
          this.isUpdatingVisibility = false;
          this.notification.showError("Impossible de modifier l’archive. Réessayez.");
        }
      });
    }
  }

  details(){
    this.router.navigate(['/admin/contacts/details', this.contact.id]);
  }

  confirmDelete(): void {
    this.menuOpen = false;
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
  }

  deleteContact(): void {
    this.contactService.deleteContact(this.contact.id).subscribe({
      next: () => {
        this.showDeleteModal = false;
        this.contactDeleted.emit();
      },
      error: (error) => {
        console.error('Error deleting contact:', error);
        this.notification.showError('Erreur lors de la suppression du demande de contact');
        this.showDeleteModal = false;
      }
    });
  }

  truncateSubject(): string {
    if (this.contact.subject.length <= 20) return this.contact.subject;
    return this.contact.subject.substring(0, 20).trim() + '...';
  }
}
